import React from 'react';
import { Check, Circle, ArrowRight, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';

/**
 * Primeros pasos del profesional.
 *
 * Un profesional aprobado pero sin horario ni perfil completo no le aparece a
 * nadie, y no tiene cómo saber por qué. Esto lo convierte en una lista concreta
 * y desaparece sola cuando ya está todo listo.
 */
export const PrimerosPasos = ({ datos, onIr }) => {
  if (!datos || datos.completados === datos.total) {
    return null;
  }

  const { pasos, completados, total, porcentaje, listo_para_recibir: listo, falta_esencial: faltan } = datos;

  return (
    <Card className={listo ? 'border-slate-200 dark:border-slate-800' : 'border-amber-300 dark:border-amber-500/40 bg-amber-50/40 dark:bg-amber-500/5'}>
      <CardContent className="py-6">
        <div className="flex flex-wrap items-start justify-between gap-4 mb-5">
          <div>
            <h2 className="font-heading text-lg font-semibold text-slate-900 dark:text-slate-100 flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-teal-600" />
              Termina de configurar tu cuenta
            </h2>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
              {listo ? (
                <>Ya puedes recibir pacientes. Estos detalles ayudan a que te elijan.</>
              ) : (
                <>
                  Te falta{' '}
                  <strong className="text-amber-900 dark:text-amber-300">{faltan.join(' y ').toLowerCase()}</strong>.
                  Hasta entonces no apareces con horas disponibles.
                </>
              )}
            </p>
          </div>

          <div className="text-right flex-none">
            <p className="font-heading text-2xl font-semibold text-slate-900 dark:text-slate-100">
              {completados}/{total}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400">completado</p>
          </div>
        </div>

        <div
          className="h-1.5 rounded-full bg-slate-200 dark:bg-slate-800 overflow-hidden mb-5"
          role="progressbar"
          aria-valuenow={porcentaje}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Avance de la configuración"
        >
          <div
            className="h-full bg-teal-600 transition-all duration-500"
            style={{ width: `${porcentaje}%` }}
          />
        </div>

        <ul className="space-y-1">
          {pasos.map((paso) => (
            <li key={paso.id}>
              <button
                type="button"
                onClick={() => !paso.listo && onIr(paso.ir_a)}
                disabled={paso.listo}
                className={`w-full flex items-start gap-3 text-left py-2.5 px-3 rounded-lg transition-colors ${
                  paso.listo ? 'opacity-60' : 'hover:bg-white dark:hover:bg-slate-800 cursor-pointer'
                }`}
              >
                {paso.listo ? (
                  <span className="w-5 h-5 rounded-full bg-teal-600 flex items-center justify-center flex-none mt-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </span>
                ) : (
                  <Circle
                    className={`w-5 h-5 flex-none mt-0.5 ${
                      paso.clave ? 'text-amber-500' : 'text-slate-300 dark:text-slate-600'
                    }`}
                  />
                )}

                <span className="min-w-0 flex-1">
                  <span
                    className={`block text-sm font-medium ${
                      paso.listo ? 'text-slate-500 dark:text-slate-400 line-through' : 'text-slate-900 dark:text-slate-100'
                    }`}
                  >
                    {paso.titulo}
                  </span>
                  {!paso.listo && (
                    <span className="block text-xs text-slate-500 dark:text-slate-400 mt-0.5">{paso.detalle}</span>
                  )}
                </span>

                {!paso.listo && (
                  <ArrowRight className="w-4 h-4 text-slate-400 flex-none mt-0.5" />
                )}
              </button>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default PrimerosPasos;
